import { GlassCard } from '@/components/ui/glass-card';
import { Heart, Users, Award } from 'lucide-react';

const AboutSection = () => {
  return (
    <section className="py-20 section-bg-cream">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-primary-deep mb-4">
              Das bin Ich
            </h2>
            <p className="text-xl text-primary-deep/80 max-w-3xl mx-auto">
              Sabrina Kure - Ihre Expertin für spirituelle und energetische Entwicklung
            </p>
          </div>

          {/* First Row: Image left, Text right */}
          <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
            {/* Sabrina Image */}
            <div>
              <GlassCard className="p-4 bg-white/90 border-primary-main/30">
                <div className="aspect-4/3 bg-linear-to-br from-primary-main/20 to-primary-lightest/40 rounded-2xl flex items-center justify-center">
                  <div className="text-center text-primary-deep">
                    <div className="text-6xl mb-4">👤</div>
                    <p className="text-lg font-medium">Sabrina Kure</p>
                    <p className="text-sm opacity-75">Prana Kundalini Therapeutin</p>
                  </div>
                </div>
              </GlassCard>
            </div>

            {/* Mein Herzenswunsch */}
            <div>
              <GlassCard className="p-8 bg-white/90 border-white/30">
                <div className="flex items-start space-x-4 mb-6">
                  <Heart className="h-8 w-8 text-primary-main shrink-0 mt-1" />
                  <div>
                    <h3 className="text-xl font-bold text-primary-deep mb-3">Mein Herzenswunsch</h3>
                    <p className="text-primary-deep/80 leading-relaxed">
                      Hallo zusammen, mein Name ist Sabrina Kure und ich bin eine erfahrene Mentaltrainerin, 
                      Soul und spirituelles Medium, Seelencoach, energetische Beraterin, Prana Kundalini 
                      Therapeutin und Seminarleiterin an der Prana Kundalini Akademie.
                    </p>
                  </div>
                </div>
                
                <p className="text-primary-deep/80 leading-relaxed">
                  Ich möchte Menschen und Tiere in allen Lebensbereichen helfen, unabhängig von den 
                  aktuellen Herausforderungen. Dafür setze ich mein Expertenwissen ein, um neue 
                  Perspektiven aufzuzeigen und sie daran zu erinnern, wer sie wirklich sind.
                </p>
              </GlassCard>
            </div>
          </div>

          {/* Second Row: Text left, Image right */}
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Text Cards Stack */}
            <div className="space-y-6">
              <GlassCard className="p-8 bg-white/90 border-white/30">
                <div className="flex items-start space-x-4 mb-6">
                  <Users className="h-8 w-8 text-primary-main shrink-0 mt-1" />
                  <div>
                    <h3 className="text-xl font-bold text-primary-deep mb-3">Mein Ansatz</h3>
                    <p className="text-primary-deep/80 leading-relaxed">
                      Ich arbeite mit einer Vielzahl von energetischen und physischen Werkzeugen, 
                      um den richtigen Ansatz für jeden Einzelnen zu finden. Ich bin davon überzeugt, 
                      dass jeder das Potenzial hat, sein Leben zu verändern.
                    </p>
                  </div>
                </div>
              </GlassCard>

              <GlassCard className="p-8 bg-white/90 border-white/30">
                <div className="flex items-start space-x-4">
                  <Award className="h-8 w-8 text-primary-main shrink-0 mt-1" />
                  <div>
                    <h3 className="text-xl font-bold text-primary-deep mb-3">Ausbildung & Zertifizierung</h3>
                    <p className="text-primary-deep/80 leading-relaxed">
                      Ich freue mich darauf, mein Wissen weiterzugeben und biete Ausbildungen zum 
                      zertifizierten Humanenergetiker (Prana Kundalini Therapeut/in) in fünf Modulen 
                      als Präsenzunterricht an. Ich möchte dir dabei helfen, deine Ziele zu erreichen 
                      und dein volles Potential zu entfalten.
                    </p>
                  </div>
                </div>
              </GlassCard>
            </div>

            {/* Second Sabrina Image */}
            <div>
              <GlassCard className="p-4 bg-white/90 border-primary-main/30">
                <div className="aspect-4/3 bg-linear-to-br from-primary-main/20 to-primary-lightest/40 rounded-2xl flex items-center justify-center">
                  <div className="text-center text-primary-deep">
                    <div className="text-6xl mb-4">👤</div>
                    <p className="text-lg font-medium">Sabrina Kure</p>
                    <p className="text-sm opacity-75">Spirituelle Beraterin</p>
                  </div>
                </div>
              </GlassCard>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;